<template>
  <div>
    <v-chart
      :option="polar"
      autoresize
      :style="{ height: '320px', width: '100%' }"
    />
  </div>
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

import variables from '@/styles/variables.scss'

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent
])

export default {
  components: {
    VChart
  },
  props: {
    data: Array,
    color: Array
  },
  data() {
    return {
      polar: {}
    }
  },
  created() {
    this.chart()
  },
  watch: {
    data: {
      handler(newOptionValue) {
        this.chart()
      }
    }
  },
  methods: {
    chart() {
      this.polar = {
        textStyle: {
          fontFamily: variables.fontFamily
        },
        color: this.color,
        title: {
          text: 'Speech',
          left: 10
        },
        tooltip: {
          trigger: 'item',
          formatter: params => {
            return `${params.name}: ${params.data.value.toLocaleString()} (${
              params.percent
            }%)`
          }
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            center: ['50%', '55%'],
            radius: ['30%', '50%'],
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: true,
                fontSize: '14',
                fontWeight: 'bold'
              }
            },
            label: {
              formatter: params => {
                return `${params.name} \n ${params.percent}%`
              }
            },
            labelLine: {
              show: true
              // length: 5,
              // length2: 10
            },
            data: this.data
          }
        ],
        animationDuration: 2000
      }
    }
  }
}
</script>
